import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GoogleMap, StreetViewPanorama } from '@react-google-maps/api';
import React, { Component } from 'react';
import classes from './FullscreenMap.module.css';
import DefaultLocationIcon from 'assets/images/default-location-icon@2x.png';
import LocationIcon from 'assets/images/location@3x.png';
import IconMapMarker from 'components/Maps/IconMapMarker/IconMapMarker';
import SideDrawer from 'components/UI/SideDrawer/SideDrawer';
import { importantPlaceIcons } from 'shared/utility';

class FullscreenMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mapTypeId: this.props.mapTypeId,
      mapLegendExpanded: true,
      zoom: this.props.mapTypeId === 'streetview' ? 15 : parseInt(this.props.zoom, 10),
    };
    this.map = React.createRef();
    this.streetView = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (this.props.mapTypeId !== prevProps.mapTypeId) {
      this.setState({ mapTypeId: this.props.mapTypeId, zoom: this.props.zoom ? parseInt(this.props.zoom, 10) : 7 });
    }
  }

  handleMapTypeChange = (mapTypeId) => {
    this.setState({ mapTypeId });
  };

  handleClose = () => {
    this.setState({ mapTypeId: this.props.mapTypeId });
    this.props.close();
  };

  returnToMapCenter = () => {
    if (this.map.current) {
      const latLng = new window.google.maps.LatLng(this.props.geoLocation.lat, this.props.geoLocation.lng);
      this.map.current.state.map.panTo(latLng);
    }
  };

  handleZoomChange = (direction) => {
    if (direction === 'plus' && this.state.zoom < 22) {
      this.setState({ zoom: this.state.zoom + 1 });
    } else if (direction === 'minus' && this.state.zoom >= 4) {
      this.setState({ zoom: this.state.zoom - 1 });
    }
  };

  render = () => {
    let postLocationMap = null;
    const fullscreenMapContainerClasses = [classes.FullscreenMapContainer];
    const legendContentsClasses = [classes.LegendContents];

    const mapContainerStyle = {
      height: '100vh',
      width: '100%',
      borderRadius: '0%',
    };

    const mapOptions = {
      mapDataProviders: '',
      mapTypeId: this.state.mapTypeId ? (this.state.mapTypeId === 'satellite' ? 'hybrid' : this.state.mapTypeId) : 'roadmap',
      zoomControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      rotateControl: false,
      scrollwheel: false,
      mapTypeControl: false,
      minZoom: 3,
    };

    const streetViewPanoramaOptions = {
      zoomControl: false,
      controlSize: false,
      clickToGo: false,
      addressControl: false,
      mapTypeControl: false,
      scaleControl: true,
      panControl: false,
      disableDefaultUI: false,
      streetViewControl: false,
      rotateControl: false,
      scrollwheel: false,
      fullscreenControl: false,
      enableCloseIcon: false,
      enableCloseButton: false,
    };
    if (this.props.post !== null) {
      postLocationMap = (
        <GoogleMap
          id="marker-example"
          ref={this.map}
          mapTypeId={this.state.mapTypeId ? (this.state.mapTypeId === 'satellite' ? 'hybrid' : this.state.mapTypeId) : 'roadmap'}
          mapContainerStyle={mapContainerStyle}
          zoom={this.state.mapTypeId === 'streetview' ? 15 : parseInt(this.state.zoom, 10)}
          center={this.props.center}
          defaultCenter={this.props.center}
          options={mapOptions}
        >
          {this.state.mapTypeId === 'streetview' ? (
            <StreetViewPanorama
              position={this.props.geoLocation}
              pov={{ pitch: this.props.pitch ? parseFloat(this.props.pitch) : 0, heading: this.props.heading ? parseFloat(this.props.heading) : 90 }}
              options={streetViewPanoramaOptions}
              visible
            >
              {' '}
            </StreetViewPanorama>
          ) : (
            <IconMapMarker markerColor={this.props.markerColor} locationIcon={this.props.locationIcon} geoLocation={this.props.geoLocation} />
          )}
        </GoogleMap>
      );
    }

    let legendLocation = null;
    if (this.props.location.length > 0) {
      const importantPlaceIcon =
        importantPlaceIcons.filter((icon) => icon.name === this.props.locationIcon).length > 0
          ? importantPlaceIcons.find((icon) => icon.name === this.props.locationIcon)
          : null;
      legendLocation = (
        <div>
          <div className={classes.Location}>
            {importantPlaceIcon ? (
              <importantPlaceIcon.image fillColor="#01a2db" type="FullscreenMapLegendIcon" />
            ) : (
              <img src={DefaultLocationIcon} className={classes.LocationIcon} alt="location-icon" />
            )}
            <h3>{this.props.location}</h3>
          </div>
          <div className={classes.Address}>
            <h4>{this.props.location2}</h4>
          </div>
        </div>
      );
    } else if (this.props.location.length === 0) {
      legendLocation = (
        <div>
          <div className={classes.Address}>
            <img src={DefaultLocationIcon} className={classes.LocationIcon} alt="location-icon" />
            <h4>{this.props.location2}</h4>
          </div>
        </div>
      );
    }

    if (this.props.show) fullscreenMapContainerClasses.push(classes.Shown);
    if (this.state.mapLegendExpanded) legendContentsClasses.push(classes.Shown);
    return (
      <div className={fullscreenMapContainerClasses.join(' ')}>
        <SideDrawer
          show={this.state.mapLegendExpanded}
          toggle={() => this.setState({ mapLegendExpanded: !this.state.mapLegendExpanded })}
          topPosition="30px"
          width="356px"
        >
          <div className={legendContentsClasses.join(' ')}>
            {legendLocation}
            <div className={classes.MapTypeControls}>
              <span
                onClick={() => this.handleMapTypeChange('roadmap')}
                className={this.state.mapTypeId === 'roadmap' ? classes.Selected : classes.Unselected}
              >
                Map
              </span>
              <span
                onClick={() => this.handleMapTypeChange('satellite')}
                className={this.state.mapTypeId === 'satellite' ? classes.Selected : classes.Unselected}
              >
                Satellite
              </span>
              <span
                onClick={() => this.handleMapTypeChange('streetview')}
                className={this.state.mapTypeId === 'streetview' ? classes.Selected : classes.Unselected}
              >
                Street
              </span>
            </div>
          </div>
        </SideDrawer>
        <FontAwesomeIcon icon="times" className={classes.CloseMapIcon} onClick={this.handleClose} />
        <div className={classes.MapThumb}>{postLocationMap}</div>
        {this.state.mapTypeId !== 'streetview' ? (
          <div className={classes.MapControls}>
            <img src={LocationIcon} onClick={this.returnToMapCenter} className={classes.ReturnToCenterIcon} alt="map marker" />

            <div className={classes.ZoomControls}>
              <FontAwesomeIcon icon="plus" onClick={() => this.handleZoomChange('plus')} className={classes.ZoomIn} />
              <FontAwesomeIcon icon="minus" onClick={() => this.handleZoomChange('minus')} className={classes.ZoomOut} />
            </div>
          </div>
        ) : null}
      </div>
    );
  };
}

export default FullscreenMap;
